import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { FreelancerReviews as FreelancerReviewsContainer, FILTER_TYPES } from '@fiverr-private/reviews';
import { SafeWrapper } from '@fiverr-private/seller_pages_toolbox';
import { useFreelancerPageContext } from '../../FreelancerPageContext';
import { useLocalizationContext } from '../../../contexts/LocalizationContext';
import { CLIENT_REST_ROUTE } from '../../../routes/constants';

import './style.scss';

const PAGE_AJAX_PATH = 'freelancer_page_ajax';

/** @type {import('./index').FreelancerReviews} */
const FreelancerReviews = ({ reviewsData }) => {
    const { pageCtxId, userId } = getContext();
    const { gigs, username } = useFreelancerPageContext();
    const { currency } = useLocalizationContext();

    const pathfinderConfig = {
        path: PAGE_AJAX_PATH,
        params: {
            // Can't use ClientRestRoutes here, otherwise it adds additional /freelancer/ajax in the beggining
            endpoint: `reviews?username=${username}`,
        },
    };

    const enrichData = {
        pathFinderConfig: pathfinderConfig,
        type: FILTER_TYPES.relevant,
        pageCtxId,
        pageName: 'freelancer_page',
        biEventGroup: 'freelancer_page',
        currentUserId: userId,
        displayRelevant: true,
        displayBreakdown: true,
        displayLoyalty: true,
        gigsData: gigs,
    };

    return (
        <FreelancerReviewsContainer
            initialState={{ ...reviewsData, ...enrichData }}
            currencyConfig={currency}
            translationUrl={CLIENT_REST_ROUTE.REVIEWS_TRANSLATIONS}
            enableSearchFilter={reviewsData.isReviewsSearchEnabled}
        />
    );
};

/** @type {typeof FreelancerReviews} */
const SafeFreelancerReviews = SafeWrapper(FreelancerReviews, 'FreelancerReviews');

export { SafeFreelancerReviews as FreelancerReviews };
export default SafeFreelancerReviews;
